<template>
  <span class="hs-tooltip" :class="`hs-tooltip--${placement}`">
    <slot />
    <span class="hs-tooltip__bubble" role="tooltip">{{ text }}</span>
  </span>
</template>

<script>
export default {
  name: "HsTooltip",
  props: {
    text: { type: String, required: true },
    placement: {
      type: String,
      default: "top",
      validator: (value) => ["top", "right", "bottom", "left"].includes(value),
    },
  },
};
</script>

<style scoped>
.hs-tooltip {
  display: inline-flex;
  position: relative;
}

.hs-tooltip__bubble {
  background: #111827;
  border-radius: 10px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.16);
  color: #fff;
  font-size: 0.72rem;
  font-weight: 800;
  max-width: 220px;
  opacity: 0;
  padding: 0.45rem 0.6rem;
  pointer-events: none;
  position: absolute;
  text-align: center;
  transition: opacity 0.16s ease, transform 0.16s ease;
  white-space: normal;
  width: max-content;
  z-index: 5400;
}

.hs-tooltip--top .hs-tooltip__bubble {
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
}

.hs-tooltip--right .hs-tooltip__bubble {
  left: calc(100% + 8px);
  top: 50%;
  transform: translateX(-4px) translateY(-50%);
}

.hs-tooltip--bottom .hs-tooltip__bubble {
  left: 50%;
  top: calc(100% + 8px);
  transform: translateX(-50%) translateY(-4px);
}

.hs-tooltip--left .hs-tooltip__bubble {
  right: calc(100% + 8px);
  top: 50%;
  transform: translateX(4px) translateY(-50%);
}

.hs-tooltip:hover .hs-tooltip__bubble,
.hs-tooltip:focus-within .hs-tooltip__bubble {
  opacity: 1;
}

.hs-tooltip--top:hover .hs-tooltip__bubble,
.hs-tooltip--top:focus-within .hs-tooltip__bubble {
  transform: translateX(-50%) translateY(0);
}

.hs-tooltip--right:hover .hs-tooltip__bubble,
.hs-tooltip--right:focus-within .hs-tooltip__bubble {
  transform: translateX(0) translateY(-50%);
}

.hs-tooltip--bottom:hover .hs-tooltip__bubble,
.hs-tooltip--bottom:focus-within .hs-tooltip__bubble {
  transform: translateX(-50%) translateY(0);
}

.hs-tooltip--left:hover .hs-tooltip__bubble,
.hs-tooltip--left:focus-within .hs-tooltip__bubble {
  transform: translateX(0) translateY(-50%);
}
</style>
